// oxlint-disable-next-line eslint/no-redeclare
export const Editions = {
	FREE: 'free',
	STANDARD: 'standard',
	PREMIUM: 'premium',
	ESSENTIALS: 'essentials',
	ENTERPRISE: 'enterprise',
} as const;
export type Editions = (typeof Editions)[keyof typeof Editions];

export type EditionExtensionsOptions = {
	edition?: Editions;
};

export type AdminHubExtensionsOptions = {
	grantAccessTo?: string;
	migrationSourceUuid?: string;
} & EditionExtensionsOptions; // Edition extension options included for legacy reasons. Do not include in new extensions

export type StartExtensionsOptions = {
	migrationSourceUuid?: string;
} & EditionExtensionsOptions; // Edition extension options included for legacy reasons. Do not include in new extensions

export type RecommendationExtensionsOptions = {
	entityId: string;
	recommendationSessionId: string;
};

export type ProvisioningPageExtensionsOptions = {
	actions: Actions;
};

export type ProvisioningApiExtensionsOptions = {
	actions: Actions;
	jobName: string;
	jobParams: {
		[key: string]: any;
	};
};

// oxlint-disable-next-line eslint/no-redeclare
export const Behaviours = {
	LAND: 'land',
	CLOSE: 'close',
} as const;
export type Behaviours = (typeof Behaviours)[keyof typeof Behaviours];

// oxlint-disable-next-line eslint/no-redeclare
export const TargetTabs = {
	SAME: 'same',
	NEW: 'new',
} as const;
export type TargetTabs = (typeof TargetTabs)[keyof typeof TargetTabs];

// oxlint-disable-next-line eslint/no-redeclare
export const Prompts = {
	NEXT: 'next',
	CLOSE: 'close',
	GO_TO_PRODUCT: 'go-to-product',
	RETURN_TO_PRODUCT: 'return-to-product',
} as const;
export type Prompts = (typeof Prompts)[keyof typeof Prompts];

type LandBehaviourOptions = {
	behaviour: typeof Behaviours.LAND;
	options?: {
		targetTab?: TargetTabs;
		urlParams?: {
			[key: string]: string | number;
		};
	};
	prompt: Prompts;
};

type CloseBehaviourOptions = {
	behaviour: typeof Behaviours.CLOSE;
	prompt: Prompts;
};

type Action = CloseBehaviourOptions | LandBehaviourOptions;

type Actions = { primary: Action; secondary?: Action } | { primary?: Action; secondary: Action };
